import AssignDealRevenueManagementModal from "./AssignDealRevenueManagementModalContainer";

export default AssignDealRevenueManagementModal;
